module.exports = __webpack_public_path__ + "static/media/rome-18.f89c27d5.jpg";